<template>
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" :model="form" ref="form" label-width="auto">
        <el-row type="flex" :gutter="20">


          <el-col :span="6">
            <el-form-item label="证件类型：">
              <el-select v-model="form.type" placeholder="请选择证件类型">
                <el-option v-for="item in cardList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="证件号码：">
              <el-input v-model="form.name" placeholder="请输入证件号码 "></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="黑名单状态：">
              <el-select v-model="form.type" placeholder="请选择证件类型">
                <el-option v-for="item in blackStatus" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>


          <el-col :span="6">
            <div class="tr">
              <el-button type="primary" @click="getTableList">查询</el-button>
              <el-button @click="resetForm('form')">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">

      <div class="button">
        <el-row type="flex">
          <el-popover placement="bottom" width="150" trigger="click">
            <el-checkbox-group @change="handleCheck" v-model="checkList">
              <el-checkbox :label="item.propName" v-for="(item, i) in checkLabels" :key="i" style="display: block;">{{
                item.label }}</el-checkbox>
            </el-checkbox-group>
            <span class="icon-wrapper" slot="reference">
              <svg-icon icon-class="shaixuan" class-name="icon-menu" />
            </span>
          </el-popover>

          <el-popover class="pop-wrapper" placement="bottom" width="150" trigger="click">
            <span class="icon-wrapper" slot="reference">
              <svg-icon icon-class="export" class-name="icon-menu" />
            </span>
          </el-popover>

          <span class="icon-wrapper">
            <svg-icon icon-class="print" class-name="icon-menu" />
          </span>

        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" :row-key="(row) => { return row.id }" stripe
          :data="tableData">
          <!-- <el-table-column type="selection" :reserve-selection="true" width="42"></el-table-column> -->
          <template v-for="item in checkLabels">
            <el-table-column v-if="item.show" :prop="item.propName" :label="item.label" :key="item.label"
              show-overflow-tooltip>
            </el-table-column>
          </template>
          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" width="auto">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleHistory(scope.row)">历史记录</a>
              <a class="m-btn m-danger" @click="handleEdit(scope.row)">解除</a>

            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <dialog-order ref="dialogOrder"></dialog-order>
  </div>
</template>

<script>
import dialogOrder from './dialogs/order-dialog'

export default {
  data() {
    return {
      form: {
        name: '',
      },
      value1: '',
      blackStatus: [{ value: '0', label: '否' }, { value: '1', label: '是' },],
      cardList: [{ value: '1', label: '身份证' }, { value: '2', label: '护照' }, { value: '3', label: '港澳台通行证' }, { value: '4', label: '外国人永居证' }],
      // checkLabels: [{ label: '订单号', propName: 'name' }, { label: '日期', propName: 'date' }, { label: '开始时间', propName: '' }, { label: '结束时间', propName: '' }, { label: '用户名', propName: '' }, { label: '人数', propName: '' }, { label: '姓名', propName: '' }, { label: '手机号', propName: '' }, { label: '证件类型', propName: '' }, { label: '证件号码', propName: '' }, { label: '票价类型', propName: '' }, { label: '票价', propName: '' }, { label: '订单状态', propName: '' }, { label: '入馆/取消时间', propName: '' }],
      checkLabels: [{ label: '证件类型', show: true, propName: 'cardType' }, { label: '证件号码', show: true, propName: 'cardNo' }, { label: '失约次数', show: true, propName: 'name' }, { label: '累计次数', show: true, propName: 'phone' }, { label: '是否黑名单', show: true, propName: 'name' }],
      checkList: [],
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      chooseRowIds: '',
    }
  },
  components: { dialogOrder },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$api.applet.getDigitalExhibitionList({
        ...this.form,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach(item => {
        arr.push(item.id)
      })
      this.chooseRowIds = arr.join(',')
    },

    setHead() {
      this.checkLabels.map(item => {
        this.checkList.push(item.propName)
      })
    },

    // 动态修改表头
    handleCheck(key) {
      for (let i = 0; i < this.checkLabels.length; i++) {
        if (this.checkList.includes(this.checkLabels[i].propName)) {
          this.checkLabels[i].show = true;
        } else {
          this.checkLabels[i].show = false;

        }
      }
    },


    // 重置查询
    resetForm() {
      this.form = {
        name: '',
      }
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    handleHistory() {
      this.$refs.dialogOrder.init()
    },

    handleEdit(obj) {
      this.$common
        .confirm1('确认要操作该数据?')
        .then(function () {
          // return delCollection(obj.id)
        })
        .then(res => {
          if (res.code == 0) {
            this.$message.success('删除成功')
            this.getData()
          } else {
            this.$message.error(res.msg || '系统异常')
          }
        })
        .catch(() => { })
    },

    // 删除
    handleDelete(obj) {
      this.$common
        .confirm1('是否确认删除?')
        .then(function () {
          // return delCollection(obj.id)
        })
        .then(res => {
          if (res.code == 0) {
            this.$message.success('删除成功')
            this.getData()
          } else {
            this.$message.error(res.msg || '系统异常')
          }
        })
        .catch(() => { })

    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    onSubmit() {
      const self = this
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = "addDigitalExhibition"
          if (this.addForm.id) {
            url = "updateDigitalExhibition"
          }
          this.$api.applet[url](this.addForm).then(res => {
            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '数字展厅修改成功' : '新增数字展厅成功',
                duration: 500,
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {}
                  self.imgUrl = ""
                  self.getData()
                }
              })
            }
          })
        } else {
          return false;
        }
      });
    },

    guide(obj) {
      this.$router.push({
        path: '/applet-management/guide-management',
        query: { guideId: obj.id }
      })
    },
  },

  beforeUpdate() {
    this.$nextTick(() => { //在数据加载完，重新渲染表格
      this.$refs['multipleTable'].doLayout()
    })
  },
  created() {
    this.setHead()
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  .com-list-header {
    padding-right: 30px;

    .el-row--flex {
      flex-wrap: wrap;
    }
  }

  .com-list-content {
    .el-row--flex {
      justify-content: end;
    }
  }

  .icon-wrapper {
    display: flex;
    width: fit-content;
    padding: 6px;
    margin-left: 20px;
    border: 1px solid #ccc;
    justify-content: center;
    align-items: center;

    &:hover {
      cursor: pointer;
      border: 1px solid #999;
      transition: .5s all;

    }

    .icon-menu {
      font-size: 20px;
    }
  }
}
</style>